<template>
    <div>
        <div class="row justify-content-center">
            <div class="col-12">
                <div class="form-group" :class="{ 'form-group--error': $v.org.$error}">
                    <select-group v-model="org" :list="orgs" :fieldValue="'AD_Org_ID'"
                                  :fieldText="'Name'" :isDisabled="isDisabled" :idOrg="true"
                                  :isPending="isAgencyPending || isWorkHoursPending"
                                  id="org" name="org" :className="status($v.org)">
                        <option selected value="">-- {{'Organization' | trans}} --</option>
                        <template slot="after">
                            <ul class="org__messages invalid-feedback list-unstyled" v-if="$v.org.$error">
                                <li v-if="!$v.org.required">
                                    {{'Organization required' | trans}}
                                </li>
                            </ul>
                        </template>
                    </select-group>
                    <form-errors :field-name="'org'"/>
                </div>
                <div v-if="showCountries" class="form-group">
                    <select-group v-model="altCountry" :list="altCountries" :fieldValue="'C_Country_ID'"
                                  :fieldText="'C_Name'" :isDisabled="isDisabled" :isPending="isSubWorkHoursPending"
                                  id="altCountry" name="altCountry">
                        <option selected value="">-- {{'Country' | trans}} --</option>
                    </select-group>
                </div>
                <div v-if="showAgencies" class="form-group" :class="{ 'form-group--error': $v.subOrg.$error}">
                    <select-group-search v-model="subOrg" :list="agenciesByCountry" :fieldValue="'AD_Org_ID'"
                                  :fieldText="'Name'" :isDisabled="isDisabled" :isPending="isSubWorkHoursPending"
                                  id="subOrg" name="subOrg" :className="status($v.subOrg)">
                        <option selected value="">-- {{'Agency' | trans}} --</option>
                        <template slot="after">
                            <ul class="org__messages invalid-feedback list-unstyled" v-if="$v.subOrg.$error">
                                <li v-if="!$v.subOrg.required">
                                    {{'Agency required' | trans}}
                                </li>
                            </ul>
                        </template>
                    </select-group-search>
                    <form-errors :field-name="'subOrg'" />
                </div>
                <div class="form-group" v-if="showSubmitButton">
                    <spinner-button  v-if="!hideButton" :className="'btn btn-danger w-100'" @click="submit"
                                     :is-pending="isPending" :disabled="isDisabled">
                        {{'Set Default Organization' | trans}}
                    </spinner-button>
                    <div v-else>
                        {{'Please wait ...' | trans}}
                    </div>
                </div>
                <div class="text-center mt-5" v-else><b>{{workHoursMessage}}</b></div>
            </div>
        </div>
    </div>
</template>

<script>
    const { required } = require('vuelidate/lib/validators');
    import { validationMixin } from 'vuelidate';

    export default {
        mixins: [validationMixin],
        name: "set-default-org",
        props: ['orgs', 'route', 'landingRoute', 'defaultOrg', 'defaultSubOrg', 'partnerId'],
        data() {
            return {
                org: '',
                subOrg: '',
                subOrgs: [],
                altCountry: '',
                altCountries: [],
                isPending: false,
                isAgencyPending: false,
                isWorkHoursPending: false,
                isSubWorkHoursPending: false,
                isDisabled: false,
                hideButton: false,
                orgAllowed: true,
                subOrgAllowed: true,
                workHoursMessage: ''
            }
        },
        mounted() {
            this.org = this.defaultOrg;
            // this.subOrg = this.defaultSubOrg;
        },
        watch: {
            org(value) {
                if(!value){
                    this.org = '';
                }
                this.subOrgs = [];
                this.altCountries = [];
                let cOrg = this.orgs.find((item) => { return item.AD_Org_ID == value; });
                if(cOrg) {
                    if(cOrg.AD_OrgType_ID == this.partnerId) {
                        this.loadAgencies();
                        this.orgAllowed = true;
                    } else {
                        this.loadWorkHours(value, 0);
                    }
                    if(this.org != this.defaultOrg) {
                        this.subOrg = '';
                        this.altCountry = '';
                    }
                }
                this.$store.commit(`formErrors/${this.CONSTANTS.MUTATIONS.CLEAR_ERRORS}`);
            },
            subOrg(value) {
                if(value) {
                    this.loadWorkHours(value, 1);
                }
                this.$store.commit(`formErrors/${this.CONSTANTS.MUTATIONS.CLEAR_ERRORS}`);
            },
            altCountry(value) {
                this.subOrg = '';
            }
        },
        computed: {
            showAgencies() {
                var size = 0, key;
                for (key in this.subOrgs) {
                    if (this.subOrgs.hasOwnProperty(key)) size++;
                }
                return (this.orgAllowed && size > 0);
            },
            showCountries() {
                return (this.altCountries.length && this.orgAllowed);
            },
            showSubmitButton() {
                return (this.orgAllowed && (!this.subOrg || this.subOrgAllowed));
            },
            agenciesByCountry() {
                return this.subOrgs.filter((item) => { return item.C_Country_ID == this.altCountry; });
            }
        },
        methods: {
            workHoursStatus(value, type)
            {
                if(type == 0) {
                    this.isWorkHoursPending = value;
                } else {
                    this.isSubWorkHoursPending = value;
                }
            },
            async loadWorkHours(org, type)
            {
                this.workHoursStatus(true, type);
                this.isDisabled = true;
                let result = await axios.get(`agency/${org}/workHours`)
                    .finally(() => { this.workHoursStatus(false, type); this.isDisabled=false; });
                if(type == 0) {
                    this.orgAllowed = result.data.allowed;
                } else {
                    this.subOrgAllowed = result.data.allowed;
                }
                this.workHoursMessage = result.data.message;
            },
            async loadAgencies()
            {
                this.isAgencyPending = true;
                this.isDisabled = true;
                let result = await axios.get(`agencies/${this.org}/byPartner`)
                    .finally(() => {this.isAgencyPending = false; this.isDisabled=false;});
                this.subOrgs = result.data.agencies || [];
                this.altCountries = result.data.countries || [];
            },
            async submit() {
                this.$v.$touch();
                if (!this.$v.$invalid) {
                    this.isPending = true;
                    this.isDisabled = true;
                    this.$store.commit(`formErrors/${this.CONSTANTS.MUTATIONS.CLEAR_ERRORS}`);
                    let result = await axios.post(this.route, {
                        org: this.org,
                        subOrg: this.subOrg,
                        altCountry: this.altCountry
                    })
                    .finally(() => {this.isPending = false; this.isDisabled=false;});
                    this.EventBus.$emit('event-success', Lang.get('Success'));
                    if(this.landingRoute) {
                        this.hideButton = true;
                        setTimeout(() => window.location.href = this.landingRoute, this.beforeRedirectTimeOut)
                    }
                }
            }
        },
        validations() {
            let v = {
                org: {
                    required
                },
                subOrg: {}
            };
            return v;
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/set-default-org.vue